exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vaccine{color:red}.input-search{margin-left:auto}tr.md-row:active td{background-color:#adadad}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/vaccine/vaccine.scss
// module id = 666
// module chunks = 0